module.exports = __webpack_public_path__ + "img/vasion-logo-texture.a091b6f5.png";